<template>
    <div class="content-light ticket">
        <div class="header">
            <h3>{{data.topic}}</h3>
            <el-button type="success" size="mini" v-if="data.status" @click="status(0)">{{ $t('ticket_button_statuses.close') }}</el-button>
            <el-button size="mini" v-if="!data.status" @click="status(1)">{{ $t('ticket_button_statuses.open') }}</el-button>
        </div>

        <el-form ref="form" :model="model" label-position="top" label-width="120px" v-if="data.status">
            <el-form-item :label="$t('message')" :error="error_form.message">
                <el-input type="textarea" v-model="model.message" :placeholder="$t('your_message')" :autosize="{ minRows: 4, maxRows: 10 }"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="send" :loading="loading_form">{{ $t('submit') }}</el-button>
            </el-form-item>
        </el-form>

        <el-card shadow="never" v-for="(item, index) in orderBy(data.messages, 'created_at', -1)" :key="index" class="ticket-message-item" :class="{'is_support': item.sender.id!==data.user_id}">
            <h4>{{item.sender.name}}<span><i class="el-icon-time"></i> {{ item.created_at | moment("YYYY-MM-DD HH:mm") }}</span></h4>
            <div class="content" v-html="item.message"></div>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "TicketMessage",
        data () {
            return {
                loading: false,
                data: [],
                model: {},
                error_form: {},
                loading_form: false
            }
        },
        created () {
            this.fetchData();
        },
        watch: {
            '$store.getters.getTicketUnread': {
                handler () {
                    if (this.$store.getters.getTicketUnread > 0) {
                        this.fetchData();
                    }
                },
                deep: true
            }
        },
        methods: {
            fetchData () {
                this.loading = true;
                this.$axios.get('/tickets/' + this.$route.params.id + '?expand=messages').then((res) => {
                    if (this.$store.getters.getTicketUnread > 0) {
                        this.$store.dispatch("getUnread");
                    }
                    this.data = res.data;
                    this.loading = false;

                }).catch(() => {
                    this.$router.push({ name: 'tickets' })
                })
            },
            send () {
                this.loading_form=true;
                this.$axios.post('/tickets/'+ this.$route.params.id +'/send', this.model).then((res) => {
                    this.error_form = {};
                    this.loading_form = false;
                    this.data.messages.push(res.data);
                    this.model.message='';

                }).catch((error) => {
                    this.error_form = error.response.data;
                    this.loading_form=false;
                });
            },
            status (value) {
                this.$axios.patch('/tickets/'+ this.$route.params.id, {status: value}).then((res) => {
                    this.data.status = res.data.status;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
.ticket {
    .header {
        margin-bottom:25px;
        h3 {
            display:inline;
            margin: 0px;
            font-size: 16px;
            margin-right: 15px;
        }
    }

    .ticket-message-item.is_support {
        h4 {
            color: #037bff;
        }
    }
    .ticket-message-item {
        margin-bottom: 5px;
        .content {
            margin-top: 15px;
        }
        h4 {
            display: flex;
            font-size: 14px;
            margin: 0px;
            span {
                margin-top: 1px;
                margin-left: 5px;
                color: #909399;
                font-size: 13px;
                font-weight: normal;
            }
        }
    }
}
</style>